export default "__VITE_ASSET__CKyZSuRd__"